import { Navigate, useLocation, useParams, useSearchParams } from "react-router";
import { useAuth } from "../redux/ducks/auth";
import { isBooleanTrue, isObjectEmpty, isStringNotEmpty } from "../utils/objectUtils";
import { hasAdminPermissions, hasAffiliatePermissions, hasCoveredEntityPermissions, hasHelpStaffPermissions, hasMarketingManagerPermissions, hasRepPerformancePermissions, hasRepPermissions, hasStaffManagerPermissions, hasSuperAdminPermissions } from "../utils/permissions";
import ROUTES from "../constants/routes";
import { lazy } from "react";
const NoAccessPage = lazy(() => import('../pages/NoAccess'));

export const Require2FA = ({ children }) => {
    let auth = useAuth();
    let location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    // console.log('Require2FA');
    // console.log(auth);
    // console.log(location);

    if (isObjectEmpty(auth.currentAuthUser)) {
        return <Navigate to={{ pathname: ROUTES.SIGN_IN, search: "returnUrl=" + encodeURIComponent(`${location.pathname}?${searchParams.toString()}`) }} state={{ from: location }} replace />;
    } else if (!isBooleanTrue(auth.emailVerified)) {
        return <Navigate to={{ pathname: ROUTES.VERIFY_EMAIL, search: searchParams.toString() }} state={{ from: location }} replace />;
    } else if (!isBooleanTrue(auth.hasMFA)) {
        return <Navigate to={{ pathname: ROUTES.MFA_SETUP, search: searchParams.toString() }} state={{ from: location }} replace />;
    } else {
        return children;
    }
};

export const RequireVerifiedAuth = ({ children }) => {
    let auth = useAuth();
    let location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    // console.log('RequireAuth');
    // console.log(auth);
    // console.log(location);

    if (isObjectEmpty(auth.currentAuthUser)) {
        return <Navigate to={{ pathname: ROUTES.SIGN_IN, search: "returnUrl=" + encodeURIComponent(`${location.pathname}?${searchParams.toString()}`) }} state={{ from: location }} replace />;
    } else if (!isBooleanTrue(auth.emailVerified)) {
        return <Navigate to={{ pathname: ROUTES.VERIFY_EMAIL, search: searchParams.toString() }} state={{ from: location }} replace />;
    } else {
        return children;
    }
};

export const ConditionalRequireAuth = ({ paramName, children }) => {
    let { authContext } = useAuth();
    let location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    let paramToCheck = searchParams.get(paramName) ?? null;
    // console.log('ConditionalRequireAuth', paramName, paramToCheck, "returnUrl=" + encodeURIComponent(`${location.pathname}?${searchParams.toString()}`));
    // console.log(auth);
    // console.log(location);

    if (isStringNotEmpty(paramToCheck)) {
        if (isObjectEmpty(authContext.currentAuthUser)) {
            return <Navigate to={{ pathname: ROUTES.SIGN_IN, search: "returnUrl=" + encodeURIComponent(`${location.pathname}?${searchParams.toString()}`) }} state={{ from: location }} replace />;
        } else {
            return children;
        }
    } else {
        return children;
    }
};

export const RequireAuth = ({ children }) => {
    let { authContext } = useAuth();
    let location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    // console.log('RequireAuth');
    // console.log(auth);
    // console.log(location);

    if (isObjectEmpty(authContext.currentAuthUser)) {
        return <Navigate to={{ pathname: ROUTES.SIGN_IN, search: "returnUrl=" + encodeURIComponent(`${location.pathname}?${searchParams.toString()}`) }} state={{ from: location }} replace />;
    } else {
        return children;
    }
};

export const RequireAuthAllStaff = ({ children }) => {
    let { authContext } = useAuth();
    let location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    // console.log('RequireAuthAdmin');
    // console.log(auth);
    // console.log(location);

    if (isObjectEmpty(authContext.currentAuthUser)) {
        return <Navigate to={{ pathname: ROUTES.SIGN_IN, search: "returnUrl=" + encodeURIComponent(`${location.pathname}?${searchParams.toString()}`) }} state={{ from: location }} replace />;
    } else if (!isBooleanTrue(authContext.emailVerified)) {
        return <Navigate to={{ pathname: ROUTES.VERIFY_EMAIL, search: searchParams.toString() }} state={{ from: location }} replace />;
    } else if (!isBooleanTrue(authContext.hasMFA)) {
        return <Navigate to={{ pathname: ROUTES.MFA_SETUP, search: searchParams.toString() }} state={{ from: location }} replace />;
    } else if (hasHelpStaffPermissions(authContext) || hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext)) {
        return children;
    } else {
        return <NoAccessPage />;
    }
};

export const RequireAuthHelpStaff = ({ children }) => {
    let { authContext } = useAuth();
    let location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    // console.log('RequireAuthAdmin');
    // console.log(auth);
    // console.log(location);

    if (isObjectEmpty(authContext.currentAuthUser)) {
        return <Navigate to={{ pathname: ROUTES.SIGN_IN, search: "returnUrl=" + encodeURIComponent(`${location.pathname}?${searchParams.toString()}`) }} state={{ from: location }} replace />;
    } else if (!isBooleanTrue(authContext.emailVerified)) {
        return <Navigate to={{ pathname: ROUTES.VERIFY_EMAIL, search: searchParams.toString() }} state={{ from: location }} replace />;
    } else if (!isBooleanTrue(authContext.hasMFA)) {
        return <Navigate to={{ pathname: ROUTES.MFA_SETUP, search: searchParams.toString() }} state={{ from: location }} replace />;
    } else if (hasHelpStaffPermissions(authContext)) {
        return children;
    } else {
        return <NoAccessPage />;
    }
};

export const RequireAuthRep = ({ children }) => {
    let { authContext } = useAuth();
    let location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    // console.log('RequireAuthAdmin');
    // console.log(auth);
    // console.log(location);

    if (isObjectEmpty(authContext.currentAuthUser)) {
        return <Navigate to={{ pathname: ROUTES.SIGN_IN, search: "returnUrl=" + encodeURIComponent(`${location.pathname}?${searchParams.toString()}`) }} state={{ from: location }} replace />;
    } else if (!isBooleanTrue(authContext.emailVerified)) {
        return <Navigate to={{ pathname: ROUTES.VERIFY_EMAIL, search: searchParams.toString() }} state={{ from: location }} replace />;
    } else if (!isBooleanTrue(authContext.hasMFA)) {
        return <Navigate to={{ pathname: ROUTES.MFA_SETUP, search: searchParams.toString() }} state={{ from: location }} replace />;
    } else if (hasRepPermissions(authContext)) {
        return children;
    } else {
        return <NoAccessPage />;
    }
};

export const RequireAuthStaffManager = ({ children }) => {
    let { authContext } = useAuth();
    let location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    // console.log('RequireAuthAdmin');
    // console.log(auth);
    // console.log(location);

    if (isObjectEmpty(authContext.currentAuthUser)) {
        return <Navigate to={{ pathname: ROUTES.SIGN_IN, search: "returnUrl=" + encodeURIComponent(`${location.pathname}?${searchParams.toString()}`) }} state={{ from: location }} replace />;
    } else if (!isBooleanTrue(authContext.emailVerified)) {
        return <Navigate to={{ pathname: ROUTES.VERIFY_EMAIL, search: searchParams.toString() }} state={{ from: location }} replace />;
    } else if (!isBooleanTrue(authContext.hasMFA)) {
        return <Navigate to={{ pathname: ROUTES.MFA_SETUP, search: searchParams.toString() }} state={{ from: location }} replace />;
    } else if (hasStaffManagerPermissions(authContext)) {
        return children;
    } else {
        return <NoAccessPage />;
    }
};

export const RequireAuthMarketingManager = ({ children }) => {
    let { authContext } = useAuth();
    let location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    // console.log('RequireAuthAdmin');
    // console.log(auth);
    // console.log(location);

    if (isObjectEmpty(authContext.currentAuthUser)) {
        return <Navigate to={{ pathname: ROUTES.SIGN_IN, search: "returnUrl=" + encodeURIComponent(`${location.pathname}?${searchParams.toString()}`) }} state={{ from: location }} replace />;
    } else if (!isBooleanTrue(authContext.emailVerified)) {
        return <Navigate to={{ pathname: ROUTES.VERIFY_EMAIL, search: searchParams.toString() }} state={{ from: location }} replace />;
    } else if (!isBooleanTrue(authContext.hasMFA)) {
        return <Navigate to={{ pathname: ROUTES.MFA_SETUP, search: searchParams.toString() }} state={{ from: location }} replace />;
    } else if (hasMarketingManagerPermissions(authContext)) {
        return children;
    } else {
        return <NoAccessPage />;
    }
};

export const RequireAuthIntegrationTools = ({ children }) => {
    let { authContext } = useAuth();
    let location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();

    if (isObjectEmpty(authContext.currentAuthUser)) {
        return <Navigate to={{ pathname: ROUTES.SIGN_IN, search: "returnUrl=" + encodeURIComponent(`${location.pathname}?${searchParams.toString()}`) }} state={{ from: location }} replace />;
    } else if (!isBooleanTrue(authContext.emailVerified)) {
        return <Navigate to={{ pathname: ROUTES.VERIFY_EMAIL, search: searchParams.toString() }} state={{ from: location }} replace />;
    } else if (!isBooleanTrue(authContext.hasMFA)) {
        return <Navigate to={{ pathname: ROUTES.MFA_SETUP, search: searchParams.toString() }} state={{ from: location }} replace />;
    } else if (hasAdminPermissions(authContext) || hasStaffManagerPermissions(authContext) || hasMarketingManagerPermissions(authContext)) {
        return children;
    } else {
        return <NoAccessPage />;
    }
};

export const RequireAuthAdmin = ({ children }) => {
    let { authContext } = useAuth();
    let location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    // console.log('RequireAuthAdmin');
    // console.log(auth);
    // console.log(location);

    if (isObjectEmpty(authContext.currentAuthUser)) {
        return <Navigate to={{ pathname: ROUTES.SIGN_IN, search: "returnUrl=" + encodeURIComponent(`${location.pathname}?${searchParams.toString()}`) }} state={{ from: location }} replace />;
    } else if (!isBooleanTrue(authContext.emailVerified)) {
        return <Navigate to={{ pathname: ROUTES.VERIFY_EMAIL, search: searchParams.toString() }} state={{ from: location }} replace />;
    } else if (!isBooleanTrue(authContext.hasMFA)) {
        return <Navigate to={{ pathname: ROUTES.MFA_SETUP, search: searchParams.toString() }} state={{ from: location }} replace />;
    } else if (hasAdminPermissions(authContext)) {
        return children;
    } else {
        return <NoAccessPage />;
    }
};

export const RequireAuthSuperAdmin = ({ children }) => {
    let { authContext } = useAuth();
    let location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    // console.log('RequireAuthWithRole');
    // console.log(auth);
    // console.log(location);

    if (isObjectEmpty(authContext.currentAuthUser)) {
        return <Navigate to={{ pathname: ROUTES.SIGN_IN, search: "returnUrl=" + encodeURIComponent(`${location.pathname}?${searchParams.toString()}`) }} state={{ from: location }} replace />;
    } else if (!isBooleanTrue(authContext.emailVerified)) {
        return <Navigate to={{ pathname: ROUTES.VERIFY_EMAIL, search: searchParams.toString() }} state={{ from: location }} replace />;
    } else if (!isBooleanTrue(authContext.hasMFA)) {
        return <Navigate to={{ pathname: ROUTES.MFA_SETUP, search: searchParams.toString() }} state={{ from: location }} replace />;
    } else if (hasSuperAdminPermissions(authContext)) {
        return children;
    } else {
        return <NoAccessPage />;
    }
};

export const RequireAuthWithCoveredEntityRoles = ({ roles, children }) => {
    let { authContext } = useAuth();
    let location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    let params = useParams();
    let coveredEntityId = params.coveredEntityId;
    // console.log('RequireAuthWithCoveredEntityRoles');
    // console.log(auth);
    // console.log(location);
    // console.log(params);

    if (isObjectEmpty(authContext.currentAuthUser)) {
        return <Navigate to={{ pathname: ROUTES.SIGN_IN, search: "returnUrl=" + encodeURIComponent(`${location.pathname}?${searchParams.toString()}`) }} state={{ from: location }} replace />;
    } else if (!isBooleanTrue(authContext.emailVerified)) {
        return <Navigate to={{ pathname: ROUTES.VERIFY_EMAIL, search: searchParams.toString() }} state={{ from: location }} replace />;
    } else if (!isBooleanTrue(authContext.hasMFA)) {
        return <Navigate to={{ pathname: ROUTES.MFA_SETUP, search: searchParams.toString() }} state={{ from: location }} replace />;
    } else if (hasCoveredEntityPermissions(authContext, coveredEntityId, roles)) {
        return children;
    } else {
        return <NoAccessPage />;
    }
};

export const RequireAuthWithAffiliateRoles = ({ roles, children }) => {
    let { authContext } = useAuth();
    let location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    let params = useParams();
    let affiliateId = params.affiliateId;
    // console.log('RequireAuthWithAffiliateRoles');
    // console.log(auth);
    // console.log(location);
    // console.log(params);

    if (isObjectEmpty(authContext.currentAuthUser)) {
        return <Navigate to={{ pathname: ROUTES.SIGN_IN, search: "returnUrl=" + encodeURIComponent(`${location.pathname}?${searchParams.toString()}`) }} state={{ from: location }} replace />;
    } else if (!isBooleanTrue(authContext.emailVerified)) {
        return <Navigate to={{ pathname: ROUTES.VERIFY_EMAIL, search: searchParams.toString() }} state={{ from: location }} replace />;
    } else if (!isBooleanTrue(authContext.hasMFA)) {
        return <Navigate to={{ pathname: ROUTES.MFA_SETUP, search: searchParams.toString() }} state={{ from: location }} replace />;
    } else if (hasAffiliatePermissions(authContext, affiliateId, roles)) {
        return children;
    } else {
        return <NoAccessPage />;
    }
};

export const RequireAuthRepPerformance = ({ children }) => {
    let { authContext } = useAuth();
    let location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();

    if (isObjectEmpty(authContext.currentAuthUser)) {
        return <Navigate to={{ pathname: ROUTES.SIGN_IN, search: "returnUrl=" + encodeURIComponent(`${location.pathname}?${searchParams.toString()}`) }} state={{ from: location }} replace />;
    } else if (!isBooleanTrue(authContext.emailVerified)) {
        return <Navigate to={{ pathname: ROUTES.VERIFY_EMAIL, search: searchParams.toString() }} state={{ from: location }} replace />;
    } else if (!isBooleanTrue(authContext.hasMFA)) {
        return <Navigate to={{ pathname: ROUTES.MFA_SETUP, search: searchParams.toString() }} state={{ from: location }} replace />;
    } else if (hasRepPerformancePermissions(authContext)) {
        return children;
    } else {
        return <NoAccessPage />;
    }
};
